import * as create from './create';
import * as createSkr from './createSkr';
import * as enteredFtr from './enteredFtr';
import * as list from './list';
import * as search from './search';
import * as record from './record';

const reducers = {
  ...create,
  ...createSkr,
  ...enteredFtr,
  ...list,
  ...search,
  ...record,
};

export default reducers;
